import { makeStyles } from '@material-ui/core'

export const CONDENSED = "'Fira Sans Condensed', 'Roboto Condensed', Roboto, sans-serif"
export const ACCENT = '#FF7B5B'

// One look for every flyout the rail opens: a list of cards, one of which may be live, and a
// row apart from them that takes whatever is on air off again.
const useRackStyles = makeStyles({
  list: {
    padding: '0 10px 10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    overflowY: 'auto',
  },
  note: {
    padding: '2px 10px 8px',
    fontSize: '12.5px',
    lineHeight: 1.4,
    color: '#9aa1aa',
  },
  card: {
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '10px',
    backgroundColor: 'rgba(255, 255, 255, 0.04)',
    overflow: 'hidden',
    transition: 'background 140ms ease-out',
  },
  cardLive: { border: `1px solid ${ACCENT}`, backgroundColor: 'rgba(255, 123, 91, 0.16)' },
  cardButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
    padding: '9px 10px',
    border: 'none',
    background: 'transparent',
    color: '#f2f3f5',
    fontSize: '14px',
    textAlign: 'left',
    cursor: 'pointer',
  },
  // A row that is a label rather than a control.
  cardButtonInert: { cursor: 'default' },
  cardLabel: { flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  cardState: {
    flex: 'none',
    fontFamily: CONDENSED,
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: '#8d939c',
  },
  hideRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
    marginTop: '6px',
    padding: '9px 10px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '10px',
    background: 'transparent',
    color: '#9aa1aa',
    fontSize: '14px',
    textAlign: 'left',
    cursor: 'pointer',
    transition: 'background 140ms ease-out, color 140ms ease-out',
    '&:hover': { background: 'rgba(255, 255, 255, 0.06)', color: '#f2f3f5' },
    '&:disabled': { opacity: 0.5, cursor: 'default' },
  },
  hideIcon: { flex: 'none' },
  teams: { display: 'flex', gap: '4px', padding: '0 10px 9px' },
  team: {
    flex: 1,
    minWidth: 0,
    height: '28px',
    padding: '0 8px',
    border: '1px solid rgba(255, 255, 255, 0.12)',
    borderRadius: '7px',
    backgroundColor: 'rgba(255, 255, 255, 0.04)',
    color: '#c8ccd2',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'pointer',
    transition: 'background 140ms ease-out',
    '&:hover': { borderColor: 'rgba(255, 255, 255, 0.3)' },
  },
  teamSelected: { border: `1px solid ${ACCENT}`, backgroundColor: ACCENT, color: '#fff' },
})

export default useRackStyles
